export const baseUrl = process.env.DWINITY_BACKEND ?? "https://api.dev.dwinity.com";
export const apiVersion = process.env.API_VERSION || "1.0";
